export default "__VITE_ASSET__B3Hv1$pU__"